import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import * as EnvioHttp from '../../../../services/api/https/deliveries/envio-rota.http'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  DateTime,
  InputText,
  PageHeader,
  Periodo,
  ThreeDots,
  CustomDataTable,
} from '../../../../components'
import {
  convertToFormatedDateString,
  getPeriodoFromLastXDays,
} from '../../../../services/util/date.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { urlReportTotalProdutosVeiculos } from '../../../../services/api/routes/deliveries.routes'
import EnvioForm from './EnvioForm'
import { gerarExcelTotalProdutos } from './TotalProdutosExcel'
import ModalDescarregarElement from './ModalDescarregarElement'
import ModalEditarElement from './ModalEditarElement'
import { getMotivoAtraso } from '../../../../services/api/https/registration/motivo-atraso.http'
import { getAjudantesAtivos } from '../../../../services/api/https/registration/ajudante.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { MOTIVO_ATRASO_URL_TYPES } from '../../Cadastros/MotivoAtraso/MotivoAtrasoHook'
import { isRouteAllowed } from '../../../../services/permission/menus'
import ModalGerarPickingElement from './ModalGerarPickingElement'
import ModalGerarPickingAutomatico from './ModalGerarPickingAutomatico'
import { useEnvioParaRotaContext } from '../../../../contexts/EntregaContext'

const FROTA_INIT = {
  fleet_id: 0,
  expected_date: '',
  vehicle_badge: '',
  driver: '',
  driver_phone: '',
  capacity_kg: 0,
  weight: 0,
  qte_sku: 0,
  occupancy_rate: '',
  qte_deliveries: 0,
  carregamento_em_posicoes: false,
  deliveries: [{}],
  departure_time: '__:__',
  vehicle_lated: false,
  motivo_atraso_id: 0,
}

const EDIT_INIT = {
  veiculos: [],
  motoristas: [],
  ajudantes: [],
  frota: {},
  motivosAtraso: [],
}

function EnvioParaRota({ history, selectedTp, dispatch }) {
  const { envioParaRotaContext, setEnvioParaRotaContext } = useEnvioParaRotaContext()
  const { pInicial, pFinal } = getPeriodoFromLastXDays(31, 7)

  // Hooks
  const [modalDescarregarHandler, setModalDescarregarHandler] = useState({
    isVisible: false,
    frota: { ...FROTA_INIT },
  })
  const [modalGerarPickingHandler, setModalGerarPickingHandler] = useState({ frota: null })
  const [modalPickingAutomaticoHandler, setModalPickingAutomaticoHandler] = useState({
    isVisible: false,
    tipo: null, // 'PorCliente' | 'PorClienteEstoque' | 'Reconferencia'
    frotas: [],
  })
  const [modalEditarHandler, setModalEditarHandler] = useState({
    isVisible: false,
    data: { ...EDIT_INIT },
  })
  const [frotas, setFrotas] = useState([])
  const [veiculos, setVeiculos] = useState([])
  const [motoristas, setMotoristas] = useState([])
  const [ajudantes, setAjudantes] = useState([])
  const [originalFrotas, setOriginalFrotas] = useState([])
  const [datasPrevistas, setDataPrevista] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [motivosAtraso, setMotivosAtraso] = useState([])
  const [notaFiscal, setNotaFiscal] = useState(envioParaRotaContext.notaFiscal || '')
  const [cidade, setCidade] = useState(envioParaRotaContext.cidade || '')
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresas, setSelectedEmpresas] = useState(envioParaRotaContext.selectedEmpresas || [])
  const [isSearching, setIsSearching] = useState(false)
  const [updatingFleetId, setUpdatingFleetId] = useState(null)
  const [periodo, setPeriodo] = useState(
    envioParaRotaContext.selectedPeriodo || { dataInicial: pInicial, dataFinal: pFinal },
  )

  useEffect(() => {
    _fetchFrotas(periodo.dataInicial, periodo.dataFinal)
    getMotivosAtraso(selectedTp)
    _fetchAjudantes()
  }, [selectedTp])

  useEffect(() => {
    setEnvioParaRotaContext(prev => ({
      ...prev,
      selectedPeriodo: periodo,
      notaFiscal,
      cidade,
      selectedEmpresas,
    }))
  }, [periodo, notaFiscal, cidade, selectedEmpresas])

  useEffect(() => {
    if (originalFrotas.length > 0) {
      _buildEmpresas(originalFrotas)
    }
  }, [originalFrotas])

  useEffect(() => {
    if (selectedEmpresas.length > 0) {
      _filtrarPorEmpresas()
    } else if (originalFrotas.length > 0) {
      setFrotas(originalFrotas)
    }
  }, [selectedEmpresas, originalFrotas])

  // Events
  const onBtnVoltar = () => {
    history.goBack()
  }

  const onBtnEnviarClicked = async () => {
    try {
      const selectedFrotas = frotas.filter(f => f.selected)
      if (selectedFrotas.length === 0) throw new Error('Não existe nenhum Veículo selecionado.')

      const invalidFrotas = selectedFrotas.filter(f => !f.deliveries || f.deliveries.length === 0)
      if (invalidFrotas.length > 0) {
        const labels = invalidFrotas
          .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
          .join(' , ')
        dispatch(
          showMessageBox(
            null,
            `Não é possível enviar para rota pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
          ),
        )
        return
      }

      dispatch(showLoadingBox('Enviando o(s) veículo(s) para rota . . . ', 'Aguarde:'))
      const associacoes_ids = []
      selectedFrotas.forEach(f => {
        f.deliveries.forEach(d => {
          associacoes_ids.push(d.associacao_id)
        })
      })
      await EnvioHttp.enviarParaRota(associacoes_ids)
      dispatch(hideLoadingBox())
      dispatch(showMessageBox('Veículo(s) enviados para Rota com sucesso', null))
      _fetchFrotas(periodo.dataInicial, periodo.dataFinal)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onCheckBoxRowClicked = (frota, checked) => {
    const index = frotas.findIndex(f => f.fleet_id === frota.fleet_id)
    if (index !== -1) {
      frotas[index].selected = checked
      setFrotas([...frotas])
    }
  }

  const onMenuItemClicked = (item, frota) => {
    switch (item) {
      case 'Editar':
        setModalEditarHandler({
          isVisible: true,
          data: { veiculos, motoristas, ajudantes, frota, motivosAtraso },
        })
        break
      case 'Descarregar':
        if (!frota.deliveries || frota.deliveries.length === 0) {
          dispatch(
            showMessageBox(null, 'Usuário não tem acesso a todas as empresas associadas a rota'),
          )
          return
        }
        if (frota.mapa_emitido) {
          dispatch(
            showMessageBox(
              null,
              'Não é possível descarregar entregas de uma frota com mapa de carga já emitido',
            ),
          )
          return
        }
        setModalDescarregarHandler({ isVisible: true, frota: frota })
        break
      case 'Gerar Picking':
        if (!frota.deliveries || frota.deliveries.length === 0) {
          dispatch(
            showMessageBox(null, 'Usuário não tem acesso a todas as empresas associadas a rota'),
          )
          return
        }
        setModalGerarPickingHandler({ frota: frota })
        break
      default:
        break
    }
  }

  const onSelecionarTodosClicked = checked => {
    const selectedFrotas = frotas.map(f => ({ ...f, selected: checked }))
    setFrotas(selectedFrotas)
  }

  const onCarregamentoEmPosicoesChange = async (frota, checked) => {
    if (updatingFleetId !== null) return

    setUpdatingFleetId(frota.fleet_id)
    dispatch(showLoadingBox('Aguarde...', 'Atualizando carregamento em posições'))

    try {
      const fetchedFrota = await EnvioHttp.alterarCarregamentoEmPosicoes(frota.fleet_id, checked)

      setFrotas(prevState =>
        prevState.map(item =>
          item.fleet_id === fetchedFrota.fleet_id ? { ...item, ...fetchedFrota } : item,
        ),
      )

      setOriginalFrotas(prevState =>
        prevState.map(item =>
          item.fleet_id === fetchedFrota.fleet_id ? { ...item, ...fetchedFrota } : item,
        ),
      )
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setUpdatingFleetId(null)
      dispatch(hideLoadingBox())
    }
  }

  const onDataPrevistaChange = value => {
    const filteredFrotas = originalFrotas.filter(f => f.expected_date === value)
    setFrotas(filteredFrotas)
    setNotaFiscal('')
    setCidade('')
    // Um [] novo dispararia o efeito de empresas, que devolve todas as frotas e desfaz este filtro
    setSelectedEmpresas(prev => (prev.length ? [] : prev))
  }

  const buscarPorNotaFiscal = () => {
    if (!notaFiscal.trim()) {
      dispatch(showMessageBox(null, 'Digite uma Nota Fiscal para buscar'))
      return
    }
    setIsSearching(true)
    try {
      const filteredFrotas = originalFrotas.filter(frota => {
        return frota.deliveries.some(
          delivery =>
            delivery.identifier && delivery.identifier.toString().includes(notaFiscal.trim()),
        )
      })
      setFrotas(filteredFrotas)
      if (filteredFrotas.length === 0) {
        dispatch(showMessageBox(null, 'Nenhuma rota encontrada com essa Nota Fiscal'))
      }
    } finally {
      setIsSearching(false)
    }
  }

  const buscarPorCidade = () => {
    if (!cidade.trim()) {
      dispatch(showMessageBox(null, 'Digite uma Cidade para buscar'))
      return
    }
    setIsSearching(true)
    try {
      const filteredFrotas = originalFrotas.filter(frota => {
        return frota.deliveries.some(
          delivery =>
            delivery.city && delivery.city.toUpperCase().includes(cidade.trim().toUpperCase()),
        )
      })
      setFrotas(filteredFrotas)
      if (filteredFrotas.length === 0) {
        dispatch(showMessageBox(null, 'Nenhuma rota encontrada para essa Cidade'))
      }
    } finally {
      setIsSearching(false)
    }
  }

  const onModalDescarregarClose = fetchedFrotas => {
    setModalDescarregarHandler({ isVisible: false, frota: { ...FROTA_INIT } })
    if (fetchedFrotas) {
      _fetchFrotas(periodo.dataInicial, periodo.dataFinal)
    }
  }

  const onModalEditarClose = frota => {
    if (frota) {
      const index = frotas.findIndex(f => f.fleet_id === frota.fleet_id)
      const originalIndex = originalFrotas.findIndex(f => f.fleet_id === frota.fleet_id)

      if (index !== -1) {
        frotas[index] = { ...frotas[index], ...frota }
        setFrotas([...frotas])
      }

      if (originalIndex !== -1) {
        originalFrotas[originalIndex] = { ...originalFrotas[originalIndex], ...frota }
        setOriginalFrotas([...originalFrotas])
      }
    }
    setModalEditarHandler({ isVisible: false, data: { ...EDIT_INIT } })
  }

  const onExportarExcel = () => {
    const rows = [
      ['Data Prev. Entrega', 'Placa', 'Qte Entregas', 'Qte Caixas', 'Peso', 'Motorista', 'Contato'],
    ]
    frotas.forEach(f => {
      rows.push([
        convertToFormatedDateString(f.expected_date),
        f.vehicle_badge,
        f.qte_deliveries,
        f.qte_sku,
        f.weight,
        f.driver,
        f.driver_phone,
      ])
    })
    gerarArquivoExcel('frota', rows, 'frota.xlsx')
  }

  const getFleetIdsParaTotalProdutos = () => {
    const frotasSelecionadas = frotas.filter(f => f.selected)
    if (frotasSelecionadas.length === 0) throw new Error('Selecione pelo menos 01 veículo')

    const invalidFrotas = frotasSelecionadas.filter(f => !f.deliveries || f.deliveries.length === 0)
    if (invalidFrotas.length > 0) {
      const labels = invalidFrotas
        .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
        .join(' , ')
      throw new Error(
        `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
      )
    }

    return frotasSelecionadas.map(f => f.fleet_id).join(',')
  }

  const onGerarRelatorioTotalProdutos = () => {
    try {
      const fleetIds = getFleetIdsParaTotalProdutos()
      window.open(urlReportTotalProdutosVeiculos(selectedTp, fleetIds), '_blank')
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onExportarTotalProdutosExcel = async () => {
    try {
      const fleetIds = getFleetIdsParaTotalProdutos()
      dispatch(showLoadingBox('Gerando a planilha . . . ', 'Aguarde:'))
      const data = await EnvioHttp.getTotalProdutosVeiculos(selectedTp, fleetIds)
      await gerarExcelTotalProdutos(data)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Valida a seleção de veículos e abre o modal de geração automática de picking
  const abrirModalPickingAutomatico = tipo => {
    try {
      const frotasSelecionadas = frotas.filter(f => f.selected)
      if (frotasSelecionadas.length === 0) {
        dispatch(showMessageBox(null, 'Selecione pelo menos 01 veículo'))
        return
      }

      if (tipo === 'Reconferencia' && frotasSelecionadas.length > 1) {
        dispatch(showMessageBox(null, 'Selecione apenas 01 veículo para a reconferência'))
        return
      }

      const invalidFrotas = frotasSelecionadas.filter(
        f => !f.deliveries || f.deliveries.length === 0,
      )
      if (invalidFrotas.length > 0) {
        const labels = invalidFrotas
          .map(f => `${convertToFormatedDateString(f.expected_date)} - ${f.vehicle_badge}`)
          .join(' , ')
        dispatch(
          showMessageBox(
            null,
            `Não é possível gerar o picking pois o usuário não tem acesso à todas as empresas associadas ao(s) veículo(s): ${labels}`,
          ),
        )
        return
      }

      setModalPickingAutomaticoHandler({ isVisible: true, tipo, frotas: frotasSelecionadas })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onGerarPicking = () => abrirModalPickingAutomatico('PorCliente')

  const onGerarPickingClienteEstoque = () => abrirModalPickingAutomatico('PorClienteEstoque')

  const onGerarPickingReconferencia = () => abrirModalPickingAutomatico('Reconferencia')

  const onSalvarPickingAutomatico = async ({
    area_association_model,
    pickingteam_id,
    preparar_para_download,
    descricoes,
  }) => {
    try {
      const { tipo, frotas: frotasSelecionadas } = modalPickingAutomaticoHandler
      setModalPickingAutomaticoHandler({ isVisible: false, tipo: null, frotas: [] })

      const nomePorFleet = new Map((descricoes || []).map(d => [d.fleet_id, d.name]))

      if (tipo === 'Reconferencia') {
        dispatch(showLoadingBox('Gerando Picking de Reconferência...'))
        const { id: user_id } = getUsuarioInfo()

        await PickingHttp.gerarPickingReconferenciaAhPartirRoteirizacao({
          fleet_id: frotasSelecionadas[0].fleet_id,
          user_id,
          area_association_model,
          pickingteam_id,
          preparar_para_download,
          picking_name: nomePorFleet.get(frotasSelecionadas[0].fleet_id),
        })
        dispatch(showMessageBox('Picking de Reconferência gerado com sucesso', null))
      } else {
        const info = frotasSelecionadas.map(fs => ({
          fleet_id: fs.fleet_id,
          picking_name: nomePorFleet.get(fs.fleet_id),
          associacoes: fs.deliveries.map(d => ({
            associacao_id: d.associacao_id,
            step_id: d.step_id,
          })),
        }))
        const payload = { info, area_association_model, pickingteam_id, preparar_para_download }

        if (tipo === 'PorClienteEstoque') {
          dispatch(showLoadingBox('Gerando o(s) Picking(s) (Cliente-Estoque)'))
          await PickingHttp.gerarPickingAhPartirRoteirizacaoClienteEstoque(payload)
          dispatch(showMessageBox('Picking Cliente-Estoque gerado com sucesso', null))
        } else {
          dispatch(showLoadingBox('Gerando o(s) Picking(s)'))
          await PickingHttp.gerarPickingAhPartirRoteirizacao(payload)
          dispatch(showMessageBox('Picking gerado com sucesso', null))
        }
      }

      _fetchFrotas(periodo.dataInicial, periodo.dataFinal)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const getModalPickingAutomaticoHeader = () => {
    const { tipo } = modalPickingAutomaticoHandler
    if (tipo === 'PorClienteEstoque') return 'Gerar Picking - Por Cliente-Estoque'
    if (tipo === 'Reconferencia') return 'Gerar Picking - Reconferência'
    return 'Gerar Picking - Por Cliente'
  }

  //Helpers
  const _fetchFrotas = async (pInicial, pFinal) => {
    dispatch(showLoadingBox('Aguarde...', 'Adquirindo informações sobre as frotas'))
    try {
      const { id: user_id } = getUsuarioInfo()
      const { fleets, vehicles, drivers } = await EnvioHttp.getFrotasParaEnvio(
        selectedTp,
        user_id,
        pInicial,
        pFinal,
      )
      setOriginalFrotas(fleets)
      setFrotas(fleets)
      setDataPrevista(_buildDataPrevista(fleets))
      setVeiculos(vehicles)
      setMotoristas(drivers)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const getMotivosAtraso = selectedTp => {
    let tps = selectedTp
    if (!tps) tps = getTps(false).map(tp => tp.id)
    getMotivoAtraso(getUsuarioInfo().id, tps, MOTIVO_ATRASO_URL_TYPES.VEICULO_T2)
      .then(motivos => setMotivosAtraso(motivos))
      .catch(err => showMessageBox(null, err))
  }

  const _fetchAjudantes = async () => {
    try {
      if (selectedTp) {
        const ajudantesAtivos = await getAjudantesAtivos(selectedTp)
        setAjudantes(ajudantesAtivos)
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const _buildDataPrevista = frotas => {
    const dtPrevistas = Array.from(new Set(frotas.map(f => f.expected_date)))
    return dtPrevistas.map(dt => ({ label: new Date(dt).toLocaleDateString(), value: dt }))
  }

  const _buildEmpresas = frotas => {
    const empresasSet = new Set()
    frotas.forEach(frota => {
      frota.deliveries.forEach(delivery => {
        if (delivery.company_name) {
          empresasSet.add(delivery.company_name)
        }
      })
    })
    const empresasArray = Array.from(empresasSet)
      .sort()
      .map(nome => ({
        name: nome,
        value: nome,
      }))
    setEmpresas(empresasArray)
  }

  const _filtrarPorEmpresas = () => {
    const empresasSelecionadas = selectedEmpresas.map(e => e.value || e.name || e)
    const filteredFrotas = originalFrotas.filter(frota => {
      return frota.deliveries.some(delivery => empresasSelecionadas.includes(delivery.company_name))
    })
    setFrotas(filteredFrotas)
  }

  const truncateTo2Decimals = value => {
    const number = Number(value)
    if (Number.isNaN(number)) return value
    return Math.trunc(number * 100) / 100
  }

  // Render
  return (
    <div>
      <PageHeader>3.7 - Envio de Veículo de Entrega para Rota</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={onBtnVoltar}>
          <div>
            <div className="p-grid">
              <div className="p-col-3">
                 <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                    Data Prevista da Rota:
                 </label>
                <Periodo
                  periodoInicial={periodo.dataInicial}
                  periodoFinal={periodo.dataFinal}
                  onPesquisar={(pInicial, pFinal) => {
                    setPeriodo({ dataInicial: pInicial, dataFinal: pFinal })
                    _fetchFrotas(pInicial, pFinal)
                  }}
                />
              </div>
            </div>
            <EnvioForm
              onBtnEnviar={onBtnEnviarClicked}
              onSelecionarTodosClicked={onSelecionarTodosClicked}
              datasPrevistas={datasPrevistas}
              onExportarExcel={onExportarExcel}
              onDataPrevistaChange={onDataPrevistaChange}
              onGerarPicking={onGerarPicking}
              onGerarPickingClienteEstoque={onGerarPickingClienteEstoque}
              onGerarPickingReconferencia={onGerarPickingReconferencia}
              onGerarRelatorioTotalProdutos={onGerarRelatorioTotalProdutos}
              onExportarTotalProdutosExcel={onExportarTotalProdutosExcel}
            />
            <div style={{ marginTop: 20 }}>
              <Fieldset legend="Filtro" toggleable collapsed={true}>
                <div className="p-grid p-align-center">
                  <div className="p-col-4">
                    <InputText
                      label="Nota Fiscal"
                      value={notaFiscal}
                      onChange={value => setNotaFiscal(value)}
                    />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 32 }}>
                    <Btn isLoading={isSearching} onClick={buscarPorNotaFiscal}>
                      Buscar
                    </Btn>
                  </div>
                  <div className="p-col-4">
                    <InputText label="Cidade" value={cidade} onChange={value => setCidade(value)} />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 32 }}>
                    <Btn isLoading={isSearching} onClick={buscarPorCidade}>
                      Buscar
                    </Btn>
                  </div>
                </div>
                <div className="p-grid p-align-center" style={{ marginTop: 10 }}>
                  <div className="p-col-4">
                    <CustomMultiSelect
                      disabled={empresas.length === 0}
                      placeholder="Selecione as empresas"
                      optionLabel="name"
                      options={empresas}
                      label="Empresas"
                      onChange={value => setSelectedEmpresas(value)}
                      value={selectedEmpresas}
                    />
                  </div>
                </div>
              </Fieldset>
            </div>
            <div style={{ marginTop: 20 }}>
              <CustomDataTable
                value={frotas}
                header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                globalFilter={globalFilter}
                emptyMessage="Não existe veículos para serem enviados para rota"
                paginator={true}
                rows={10}
              >
                <Column
                  field="selected"
                  style={tableCellCentered(60)}
                  body={frota => (
                    <CustomCheckbox
                      checked={frota.selected}
                      onChange={checked => onCheckBoxRowClicked(frota, checked)}
                    />
                  )}
                />
                <Column
                  field="expected_date"
                  header="Data Prev. Entrega"
                  style={tableCellCentered(200)}
                  body={frota => <DateTime>{frota.expected_date}</DateTime>}
                />
                <Column field="vehicle_badge" header="Placa" style={tableCellCentered(150)} />
                <Column field="driver" header="Motorista" />
                <Column
                  field={'mapa_emitido'}
                  header={'Mapa de Carga Emitido'}
                  style={tableCellCentered()}
                  body={fleet =>
                    fleet.mapa_emitido ? (
                      <div style={{ textAlign: 'center', color: 'green' }}>Sim</div>
                    ) : (
                      <div style={{ textAlign: 'center', color: 'red' }}>Não</div>
                    )
                  }
                />
                <Column field="driver_phone" header="Contato" style={tableCellCentered(150)} />
                <Column field="qte_deliveries" style={tableCellCentered()} header="Qte Identif." />
                <Column
                  field="qte_sku"
                  style={tableCellCentered()}
                  header="Qte. SKUs"
                  body={frota => truncateTo2Decimals(frota.qte_sku)}
                />
                <Column
                  field="weight"
                  style={tableCellCentered()}
                  header="Peso"
                  body={frota => truncateTo2Decimals(frota.weight)}
                />
                <Column
                  field="carregamento_em_posicoes"
                  header="Carregar em Posições"
                  style={tableCellCentered()}
                  body={frota => (
                    <CustomCheckbox
                      checked={Boolean(frota.carregamento_em_posicoes)}
                      onChange={checked => onCarregamentoEmPosicoesChange(frota, checked)}
                      disabled={updatingFleetId !== null}
                    />
                  )}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={frota => (
                    <ThreeDots
                      items={
                        isRouteAllowed(39)
                          ? ['Editar', 'Descarregar', 'Gerar Picking']
                          : ['Editar', 'Descarregar']
                      }
                      onClick={item => onMenuItemClicked(item, frota)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </CustomDataTable>
            </div>
            <ModalDescarregarElement
              frota={modalDescarregarHandler.frota}
              isVisible={modalDescarregarHandler.isVisible}
              onClose={onModalDescarregarClose}
            />
            <ModalEditarElement
              data={modalEditarHandler.data}
              isVisible={modalEditarHandler.isVisible}
              onClose={onModalEditarClose}
            />
            <ModalGerarPickingElement
              frota={modalGerarPickingHandler.frota}
              onClose={() => setModalGerarPickingHandler({ frota: null })}
            />
            <ModalGerarPickingAutomatico
              header={getModalPickingAutomaticoHeader()}
              estilo={
                modalPickingAutomaticoHandler.tipo === 'Reconferencia'
                  ? 'Reconferencia'
                  : 'Expedicao'
              }
              fleetIds={modalPickingAutomaticoHandler.frotas.map(f => f.fleet_id)}
              tpId={selectedTp}
              isVisible={modalPickingAutomaticoHandler.isVisible}
              onClose={() =>
                setModalPickingAutomaticoHandler({ isVisible: false, tipo: null, frotas: [] })
              }
              onSave={onSalvarPickingAutomatico}
            />
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(EnvioParaRota))
